import { fireLoginHandlers } from '../../utils/loginHandlers';
import { trackRegistrationComplete } from './authTracking';
import { reportRegisterAction } from '../helpers/newRelicActions';
import { setTokens, updateProfile } from './userStorageActions';

export function authTrackingHandler({ userRegistration, ga, environment }) {
    trackRegistrationComplete({ ...userRegistration, ...ga });

    const { user, emailToken, userToken } = userRegistration;
    const isEmailOnlyRegistration = emailToken && !userToken;
    setTokens({
        environment,
        ...userRegistration,
    });

    updateProfile({ environment, ...userRegistration }).then(() => {
        fireLoginHandlers(userRegistration);
    });

    reportRegisterAction({
        user,
        source: '1stdibs',
        emailOnly: isEmailOnlyRegistration,
    });
}
